{
  "article.backHeader.label": "Back",
  "common.appName": "Oma+",
  "common.brandFullName": "YTK Työelämä",
  "common.loading": "Loading…",
  "common.notFound.body": "The page you are looking for does not exist or has been removed.",
  "common.notFound.heading": "Page not found.",
  "content.unavailable.backHome": "Back to home",
  "content.unavailable.body": "The content service is temporarily unavailable. Please try again later or return to the home page.",
  "content.unavailable.heading": "Content is currently unavailable.",
  "content.hero.videoLabel": "Video",
  "routes.lakiruutu.title": "Lakiruutu",
  "routes.lakiruutu.empty": "No videos available.",
  "routes.lakiruutu.showMore": "See more details",
  "routes.lakiruutu.playNewTab": "Play video (opens in a new tab)"
}
